import React, { useState, useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import BottomNavigation from "reactjs-bottom-navigation";
import "reactjs-bottom-navigation/dist/index.css";
import { useLocation, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import LogOut from "./LogOut";
import { getUserInfo } from "../../services/profile";

export default function Dashboard() {
  const location = useLocation();
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const [logouting, setLogouting] = useState(false);
  const [user_data, setDataUser] = useState({});
  let current =
    location.pathname === "/"
      ? 0
      : location.pathname === "/limit-order"
      ? 2
      : location.pathname === "/trade-market"
      ? 1
      : location.pathname === "/account-info" ||
        location.pathname === "/edit-information"
      ? 3
      : 0;
  const navigate = useNavigate();

  const bottomNavItems = [
    {
      title: "خانه",
      icon: <img src={"/images/svg/khaneh-bottom.svg"} />,
      activeIcon: <img src={"/images/svg/khaneh-bottom.svg"} />,
    },
    {
      title: "معامله",
      icon: <img src={"/images/svg/trade-bottom.svg"} />,
      activeIcon: <img src={"/images/svg/trade-bottom.svg"} />,
    },
    {
      title: "بازار",
      icon: <img src={"/images/svg/bazaar-bottom.svg"} />,
      activeIcon: <img src={"/images/svg/bazaar-bottom.svg"} />,
    },
    {
      title: "حساب کاربری",
      icon: <img src={"/images/svg/hesab-bottom.svg"} />,
      activeIcon: <img src={"/images/svg/hesab-bottom.svg"} />,
    },
    {
      title: "فروشگاه",
      icon: <img style={{ width: 25 }} src={"/images/svg/shop.svg"} />,
      activeIcon: <img style={{ width: 25 }} src={"/images/svg/shop.svg"} />,
    },
  ];

  function handleChangePage(item) {
    let id = item.id;
    current = id;
    if (current === 0) {
      navigate("/");
    } else if (current === 1) {
      navigate("/trade-market");
    } else if (current === 2) {
      navigate("/limit-order");
    } else if (current === 3) {
      navigate("/account-info");
    } else if (current === 4) {
      window.location.href = "https://shop.talaeshow.com";
    }
  }
  useEffect(() => {
    function fetchData() {
      getUserInfo().then((res) => {
        const data = res?.data?.data;
        if (res.status == 200) {
          if (data) {
            setDataUser(data);
          }
        }
      });
    }
    fetchData();
  }, []);
  return (
    <>
      <LogOut
        changeModalStatus={logouting}
        setChangeModalStatus={(st) => setLogouting(st)}
      />

      {isTabletOrMobile ? (
        <>
          <BottomNavigation
            items={bottomNavItems}
            defaultSelected={current}
            onItemClick={handleChangePage}
          />
        </>
      ) : (
        <div className="desktop-header-after-login">
          <div className="content-wrapper-desktop-header">
            <div className="desktop-header-logo-item">
              <Link to={"/"}>
                <img src={"/images/logo-black-font.svg"} alt={""} />
              </Link>
            </div>
            <Link to={"/"} className="menu-item-desktop text-large">
              صفحه اصلی
            </Link>
            <Link to={"/trade-market"} className="menu-item-desktop text-large">
              معامله
            </Link>
            <Link to={"/limit-order"} className="menu-item-desktop text-large">
              بازار
            </Link>
            <a
              href="https://shop.talaeshow.com"
              target="_blank"
              className="menu-item-desktop text-large"
            >
              فروشگاه
            </a>
            <Link to={"/account-info"} className="menu-item-desktop text-large">
              حساب کاربری
            </Link>
            <div className="spacer" />
            {Object.keys(user_data).length > 0 && (
              <div>
                {user_data.first_name != null && user_data.last_name != null
                  ? user_data.first_name + " " + user_data.last_name
                  : "ناشناس"}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}
